import { BackgroundQuestionnaireItem } from './subsections/background/questionnaire'
import { HistoryQuestionnaireItem } from './subsections/history/questionnaire'
import { ImmunizationsQuestionnaireItem } from './subsections/immunizations/questionnaire'
import { RiskAssessmentQuestionnaireItem } from './subsections/risk-assessment/questionnaire'
import { NeurologicalQuestionnaireItem } from './subsections/neurological/questionnaire'
import { CognitivePsychosocialQuestionnaireItem } from './subsections/cognitive-psychosocial/questionnaire'
import { MusculoskeletalQuestionnaireItem } from './subsections/musculoskeletal/questionnaire'
import { LinesDrainsQuestionnaireItem } from './subsections/lines-drains/questionnaire'
import { TherapiesQuestionnaireItem } from './subsections/therapies/questionnaire'
import { SensoryQuestionnaireItem } from './subsections/sensory/questionnaire'
import { PainQuestionnaireItem } from './subsections/pain/questionnaire'
import { CardiacQuestionnaireItem } from './subsections/cardiac/questionnaire'
import { RespiratoryQuestionnaireItem } from './subsections/respiratory/questionnaire'
import { EndocrineQuestionnaireItem } from './subsections/endocrine/questionnaire'
import { GastrointestinalQuestionnaireItem } from './subsections/gastrointestinal/questionnaire'
import { IntegumentaryQuestionnaireItem } from './subsections/integumentary/questionnaire'
import { PhysicianNotificationQuestionnaireItem } from './subsections/physician-notification/questionnaire'
import { VitalsQuestionnaireItem } from './subsections/vitals/questionnaire'
import { CareCoordinationQuestionnaireItem } from './subsections/care-coordination/questionnaire'

// Main section marker
export enum MedicalBackgroundSectionQuestionnaireItem {
  MEDICAL_BACKGROUND = 'medical-background'
}

// Amalgamate all subsection questionnaire enums
export const MedicalBackgroundQuestionnaireItem = {
  ...MedicalBackgroundSectionQuestionnaireItem,
  ...BackgroundQuestionnaireItem,
  ...HistoryQuestionnaireItem,
  ...ImmunizationsQuestionnaireItem,
  ...RiskAssessmentQuestionnaireItem,
  ...NeurologicalQuestionnaireItem,
  ...CognitivePsychosocialQuestionnaireItem,
  ...MusculoskeletalQuestionnaireItem,
  ...LinesDrainsQuestionnaireItem,
  ...TherapiesQuestionnaireItem,
  ...SensoryQuestionnaireItem,
  ...PainQuestionnaireItem,
  ...CardiacQuestionnaireItem,
  ...RespiratoryQuestionnaireItem,
  ...EndocrineQuestionnaireItem,
  ...GastrointestinalQuestionnaireItem,
  ...IntegumentaryQuestionnaireItem,
  ...PhysicianNotificationQuestionnaireItem,
  ...VitalsQuestionnaireItem,
  ...CareCoordinationQuestionnaireItem
} as const

export type MedicalBackgroundQuestionnaireItem =
  (typeof MedicalBackgroundQuestionnaireItem)[keyof typeof MedicalBackgroundQuestionnaireItem]
